// extracted by mini-css-extract-plugin
export default {"link":"gz-z","disabled":"hz-z"};